import React, { useState } from 'react';
import {
  TooltipIcon,
  Link,
  InlineLoading,
  InlineLoadingStatus,
  SkeletonText
} from 'carbon-components-react';
import {
  HelpFilled16,
  Subtract16,
  Copy16,
  LocationPerson16,
  Search16,
  Add16,
  Checkmark16
} from '@carbon/icons-react';
import { getISPLink } from 'appConstants/ads';
import { ReactComponent as Number5Box } from 'assets/icons/number-5-box.svg';
import { ReactComponent as Replicate } from 'assets/icons/replicate.svg';
import { useDeviceType } from 'customHooks/useDeviceType';

export const Tools: React.FC<Props | any> = (props: Props) => {
  const {
    renewEnquiryHandler,
    copyPageLinkHandler,
    copyPageLinkState,
    showCopyPageLink,
    isSmallScreen,
    handleCLOOpenModal,
    responsesExpired,
    isLoading,
    showResponsesExpiredModal
  } = props;

  const { isMobileOrTablet } = useDeviceType();
  const [showTools, setShowTools] = useState<boolean>(true);

  const handleToggleTools = () => {
    setShowTools(!showTools);
  };

  const renderCopyPageLinkIcon = () => {
    if (copyPageLinkState === 'active') {
      return (
        <InlineLoading
          className="get-plans-actions-tools-content-first-half-row-link-loading"
          status="active"
          aria-live="assertive"
          style={isMobileOrTablet ? { minHeight: 'unset', flex: '0' } : {}}
        />
      );
    } else if (copyPageLinkState === 'error') {
      return (
        <InlineLoading
          className="get-plans-actions-tools-content-first-half-row-link-loading"
          status="error"
          aria-live="assertive"
          style={isMobileOrTablet ? { minHeight: 'unset', flex: '0' } : {}}
        />
      );
    } else if (copyPageLinkState === 'finished') {
      return (
        <Checkmark16
          className="success"
          height={isMobileOrTablet ? 20 : 16}
          width={isMobileOrTablet ? 20 : 16}
        />
      );
    }
    return (
      <Copy16
        height={isMobileOrTablet ? 20 : 16}
        width={isMobileOrTablet ? 20 : 16}
      />
    );
  };

  return (
    <div
      className={`get-plans-actions-tools ${
        responsesExpired && showResponsesExpiredModal
          ? 'get-plans-actions-tools-expired'
          : ''
      } ${isMobileOrTablet ? 'mobile-view-get-plans-actions-tools' : ''}`}
    >
      {(!responsesExpired || !showResponsesExpiredModal) && (
        <>
          <div
            className="get-plans-actions-tools-header"
            onClick={isMobileOrTablet ? undefined : handleToggleTools}
            style={isMobileOrTablet ? { padding: '0px' } : {}}
          >
            {!isMobileOrTablet && (
              <div>{showTools ? <Subtract16 /> : <Add16 />}</div>
            )}
            <div
              className="get-plans-actions-tools-header-text"
              style={isMobileOrTablet ? { marginLeft: '0px' } : {}}
            >
              TOOLS
            </div>
          </div>
          {showTools && (
            <div className="get-plans-actions-tools-content">
              <div
                className="get-plans-actions-tools-content-first-section"
                style={isMobileOrTablet ? { borderBottom: 'none' } : {}}
              >
                <div
                  className="get-plans-actions-tools-content-first-section-row"
                  style={
                    isMobileOrTablet
                      ? { padding: '0px', marginTop: '16px' }
                      : {}
                  }
                >
                  {!isLoading ? (
                    <>
                      <div className="get-plans-actions-tools-content-first-section-row-link">
                        <div className="get-plans-actions-tools-content-first-section-row-link-icon">
                          <Replicate
                            width={isMobileOrTablet ? 20 : 16}
                            height={isMobileOrTablet ? 20 : 16}
                          />
                        </div>
                        <div className="get-plans-actions-tools-content-first-section-row-link-text">
                          <Link onClick={renewEnquiryHandler}>
                            Duplicate enquiry
                          </Link>
                        </div>
                      </div>
                      {!isMobileOrTablet && (
                        <div className="get-plans-actions-tools-content-first-section-row-tooltip">
                          <TooltipIcon
                            tooltipText={`Start a new enquiry with this enquiry's values pre-filled`}
                            className="tooltip enquiry-details-tooltip"
                            align={isSmallScreen ? 'end' : 'center'}
                          >
                            <HelpFilled16 className="tooltip-icon" />
                          </TooltipIcon>
                        </div>
                      )}
                    </>
                  ) : (
                    <SkeletonText />
                  )}
                </div>
                {showCopyPageLink ? (
                  <div
                    className="get-plans-actions-tools-content-first-section-row"
                    style={
                      isMobileOrTablet
                        ? { padding: '0px', marginTop: '16px' }
                        : {}
                    }
                  >
                    <div className="get-plans-actions-tools-content-first-section-row-link">
                      {renderCopyPageLinkIcon()}
                      <div className="get-plans-actions-tools-content-first-section-row-link-text">
                        <Link
                          className={
                            copyPageLinkState === 'finished'
                              ? 'get-plans-actions-tools-content-success'
                              : ''
                          }
                          disabled={copyPageLinkState === 'active'}
                          onClick={copyPageLinkHandler}
                        >
                          {copyPageLinkState !== 'finished'
                            ? 'Copy page link'
                            : 'Copied'}
                        </Link>
                      </div>
                    </div>
                    {!isMobileOrTablet && (
                      <div className="get-plans-actions-tools-content-first-section-row-tooltip">
                        <TooltipIcon
                          tooltipText={
                            'Copy a link to this enquiry and share it with others. Note: the recipient must have a BYDA account.'
                          }
                          className="tooltip enquiry-details-tooltip"
                          align={isSmallScreen ? 'end' : 'center'}
                        >
                          <HelpFilled16 className="tooltip-icon" />
                        </TooltipIcon>
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
              <div
                className="get-plans-actions-tools-content-second-section"
                style={isMobileOrTablet ? { borderBottom: 'none' } : {}}
              >
                <div
                  className="get-plans-actions-tools-content-second-section-row"
                  style={
                    isMobileOrTablet
                      ? { padding: '0px', marginTop: '16px' }
                      : {}
                  }
                >
                  {!isLoading ? (
                    <div className="get-plans-actions-tools-content-second-section-row-link">
                      <LocationPerson16
                        height={isMobileOrTablet ? 20 : 16}
                        width={isMobileOrTablet ? 20 : 16}
                      />
                      <div className="get-plans-actions-tools-content-second-section-row-link-text">
                        <Link onClick={handleCLOOpenModal}>Find a locator</Link>
                      </div>
                    </div>
                  ) : (
                    <SkeletonText />
                  )}
                </div>
                <div
                  className="get-plans-actions-tools-content-second-section-row"
                  style={
                    isMobileOrTablet
                      ? { padding: '0px', marginTop: '16px' }
                      : {}
                  }
                >
                  {!isLoading ? (
                    <div
                      className="get-plans-actions-tools-content-second-section-row-link"
                      style={isMobileOrTablet ? { alignItems: 'center' } : {}}
                    >
                      <Number5Box
                        height={isMobileOrTablet ? 16 : 14}
                        width={isMobileOrTablet ? 16 : 14}
                      />
                      <div className="get-plans-actions-tools-content-second-section-row-link-text">
                        <Link
                          href="https://www.byda.com.au/before-you-dig/best-practice-guides/"
                          target="_blank"
                        >
                          Learn 5Ps of Damage Prevention
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <SkeletonText />
                  )}
                </div>
              </div>
              <div className="get-plans-actions-tools-content-third-section">
                <div
                  className="get-plans-actions-tools-content-third-section-row"
                  style={
                    isMobileOrTablet
                      ? { padding: '0px', marginTop: '16px' }
                      : {}
                  }
                >
                  {!isLoading ? (
                    <div className="get-plans-actions-tools-content-third-section-row-link">
                      <Search16
                        height={isMobileOrTablet ? 20 : 16}
                        width={isMobileOrTablet ? 20 : 16}
                      />
                      <div
                        className="get-plans-actions-tools-content-third-section-row-link-text"
                        style={
                          isMobileOrTablet ? { marginLeft: '0.45rem' } : {}
                        }
                      >
                        <Link
                          onClick={() =>
                            window.open(
                              getISPLink('plan-response-selection'),
                              '_blank'
                            )
                          }
                        >
                          Find equipment and contractors
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <SkeletonText />
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

type ownProps = {
  copyPageLinkState: InlineLoadingStatus;
  renewEnquiryHandler: any;
  copyPageLinkHandler: any;
  showCopyPageLink: boolean;
  isSmallScreen: boolean;
  handleCLOOpenModal: any;
  responsesExpired: boolean;
  isLoading: boolean;
  showResponsesExpiredModal: boolean;
};

type Props = ownProps;

Tools.displayName = 'Tools';

export default React.memo(Tools);
